import AccountHolderView from "../account-holder-view";


function AccountHolderCompletedView() {
  return <AccountHolderView isCompletedPrograms />
}
export default AccountHolderCompletedView;